import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const createLevel = (resource, id, { structureId, ...values }) => {
  return axios.post(`/api/${resource}/${id}/setup/level_structures/${structureId}/levels`, values);
};

export const useCreateLevel = (resource, id, onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => createLevel(resource, id, values),
    onSuccess: () => {
      enqueueSnackbar('Level successfully added', { variant: 'success' });
      onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(
        error?.response?.data?.description || error?.message || 'Some error occured',
        {
          variant: 'error',
        }
      );
    },
  });
};
